
import React, { useState, useEffect, useCallback } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { MLContactUtilsService } from 'ml-portals-services-js'

import metadata from './MLClaimDetailsKeyContact.metadata.json5';
import messages from './MLClaimDetailsKeyContact.messages';

function MLClaimDetailsKeyContact(props) {
    const {
        className,
        mainContact,
        adjuster,
        serviceRequests,
        isPersonalAuto
    } = props;

    const translator = useTranslator();
    const [cccServiceProvider, updateCccServiceProvider] = useState();
    const [homeServiceProvider, updateHomeServiceProvider] = useState();

    
    const getCCCServiceProvider = useCallback(() => {
        return serviceRequests.filter((service) => service.services[0] === 'autoapprccc')[0];
    }, [serviceRequests]);
    
    const getHomeServiceProvider = useCallback(() => {
        return serviceRequests.filter((service) => service.services[0] === 'homeservefieldinspect_ml')[0];
    }, [serviceRequests]);

    useEffect(() => {

        if (isPersonalAuto) {
            updateCccServiceProvider(getCCCServiceProvider());
        } else {
            updateHomeServiceProvider(getHomeServiceProvider());
        }
    }, [getCCCServiceProvider, getHomeServiceProvider, isPersonalAuto])


    const getPrimaryAddress = (object) => {
        const address = object && object.primaryAddress;
        if (address) {
            return <>
                {address.addressLine1}
                <br />
                {`${address.city}, ${address.state} ${address.postalCode}`}
            </>
        }
    }

    const getPhoneNumber = (number, extension, parenIndicator) => {
        if (!number) { return ''; }
        number = String(number).replace(/[^0-9]+/g, '');

        const DELIMITER = '-';
        const US_PREFIX = '1';

        // Check for a possible prefix included and remove if so
        if (number.length === 11 && number[0] === US_PREFIX) {
            number = number.slice(1);
        }

        // If the length is not 10, the number format is wrong
        if (number.length !== 10) {
            return number;
        }

        const area = number.substring(0, 3);
        const front = number.substring(3, 6);
        const end = number.substring(6, 10);
        let formattedNumber;
        if (parenIndicator) {
            formattedNumber = `(${area}) ${front}${DELIMITER}${end}`;
        } else {
            formattedNumber = area + DELIMITER + front + DELIMITER + end;
        }
        let formattedExtension = '';
        if (extension) {
            const ext = String(extension).replace(/[^0-9]+/g, '');
            if (ext) {
                formattedExtension = ` ${translator(messages.ext)} ${ext}`;
            }
        }
        return formattedNumber.concat(formattedExtension);
    }

    const getPrimaryPhoneNumber = (object) => {
        if(object){
            return MLContactUtilsService.getPrimaryPhone(object);
        }
    }

    const isRepairFacility = () => {
        return !!(cccServiceProvider && cccServiceProvider.repairFacility_ML
            && cccServiceProvider.repairFacility_ML.displayName);
    };
    const isAppraiser = () => {
        return !!(cccServiceProvider && cccServiceProvider.estimateResource_ML
            && cccServiceProvider.estimateResource_ML.displayName &&
            cccServiceProvider.estimateResource_ML.primaryAddress);
    };

    const overrides = {
        keyContactComponent: {
            className: className
        },
        contactColName: {
            content: mainContact.displayName
        },
        contactColAddress: {
            content: getPrimaryAddress(mainContact)
        },
        contactColPhone: {
            visible: !!mainContact.contactNumber_ML,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(mainContact.contactNumber_ML)}`}</>
        },
        contactColEmail: {
            visible: !!mainContact.emailAddress1,
            content: <>{`${translator(messages.Email)} ${mainContact.emailAddress1}`}</>
        },
        adjusterCol: {
            visible: !!adjuster.displayName
        },
        adjusterColName: {
            content: adjuster.displayName
        },
        adjusterColPhone: {
            visible: !!adjuster.contactNumber_ML,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(adjuster.phoneNumber)}`}</>
        },
        adjusterColEmail: {
            visible: !!adjuster.email,
            content: <>{`${translator(messages.Email)} ${adjuster.email}`}</>
        },
        homeServiceProviderCol: {
            visible: !isPersonalAuto && homeServiceProvider !== undefined
        },
        homeServiceProviderColName: {
            content: homeServiceProvider?.estimateResource_ML?.displayName
        },
        homeServiceProviderColAddress: {
            content: getPrimaryAddress(homeServiceProvider?.estimateResource_ML)
        },
        homeServiceProviderColPhone: {
            visible: !!homeServiceProvider?.estimateResource_ML?.primaryPhoneType,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(getPrimaryPhoneNumber(homeServiceProvider?.estimateResource_ML), null, true)}`}</>
        },
        homeServiceProviderColEmail: {
            visible: !!homeServiceProvider?.estimateResource_ML?.emailAddress1,
            content: <>{`${translator(messages.Email)} ${homeServiceProvider?.estimateResource_ML?.emailAddress1}`}</>
        },
        autoServiceProviderCol: {
            visible: isPersonalAuto && isAppraiser()
        },
        autoServiceProviderColName: {
            content: cccServiceProvider?.estimateResource_ML?.displayName
        },
        autoServiceProviderColAddress: {
            content: getPrimaryAddress(cccServiceProvider?.estimateResource_ML)
        },
        autoServiceProviderColPhone: {
            visible: !!cccServiceProvider?.estimateResource_ML?.primaryPhoneType,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(getPrimaryPhoneNumber(cccServiceProvider?.estimateResource_ML), null, true)}`}</>
        },
        autoServiceProviderColEmail: {
            visible: !!cccServiceProvider?.estimateResource_ML?.emailAddress1,
            content: <>{`${translator(messages.Email)} ${cccServiceProvider?.estimateResource_ML?.emailAddress1}`}</>
        },
        autoRepairFacilityCol: {
            visible: isPersonalAuto && isRepairFacility()
        },
        autoRepairFacilityColName: {
            content: cccServiceProvider?.repairFacility_ML?.displayName
        },
        autoRepairFacilityColAddress: {
            content: getPrimaryAddress(cccServiceProvider?.repairFacility_ML)
        },
        autoRepairFacilityColPhone: {
            visible: !!cccServiceProvider?.repairFacility_ML?.primaryPhoneType,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(getPrimaryPhoneNumber(cccServiceProvider?.repairFacility_ML), null, true)}`}</>
        },
        autoRepairFacilityColEmail: {
            visible: !!cccServiceProvider?.repairFacility_ML?.emailAddress1,
            content: <>{`${translator(messages.Email)} ${cccServiceProvider?.repairFacility_ML?.emailAddress1}`}</>
        },
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsKeyContact;
